import { render, staticRenderFns } from "./VisNetworkBubble.vue?vue&type=template&id=2dfdf146&"
import script from "./VisNetworkBubble.vue?vue&type=script&lang=js&"
export * from "./VisNetworkBubble.vue?vue&type=script&lang=js&"
import style0 from "./VisNetworkBubble.vue?vue&type=style&index=0&id=2dfdf146&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports